import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/** Render the view-ticket HTML block to a multi-page A4 PDF blob. */
export async function renderTicketPdfBlob(root: HTMLElement): Promise<Blob> {
  const canvas = await html2canvas(root, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
  });
  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  return pdf.output('blob');
}

export function downloadTicketPdf(blob: Blob, ticketNumber: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `SkyLux-Ticket-${ticketNumber}.pdf`;
  a.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export function printTicketPdf(blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const win = window.open(url, '_blank', 'noopener,noreferrer');
  if (!win) {
    URL.revokeObjectURL(url);
    throw new Error('Pop-up blocked. Allow pop-ups to print your ticket PDF.');
  }
  win.addEventListener('load', () => {
    win.focus();
    win.print();
  });
  window.setTimeout(() => URL.revokeObjectURL(url), 120_000);
}
